export type BarcodeScanHandler = (barcode: string) => boolean | void | Promise<boolean | void>

let barcodeScanHandler: BarcodeScanHandler | null = null

export const setBarcodeScanHandler = (handler: BarcodeScanHandler | null) => {
    barcodeScanHandler = handler
}

export const runBarcodeScanHandler = async (barcode: string): Promise<'missing' | 'rejected' | 'handled'> => {
    if (!barcodeScanHandler) return 'missing'
    const result = await barcodeScanHandler(barcode)
    return result === false ? 'rejected' : 'handled'
}
